import { FLAME, GREEN, MUTED, WHAT_WE_DO } from './asesoriaTokens'

export function AsesoriaScopeSection() {
    return (
        <section className='mx-auto flex max-w-[1200px] flex-col gap-10 px-6 pb-10 pt-20 md:pt-24'>
            <div className='flex max-w-[760px] flex-col gap-4'>
                <div className={`text-xs font-semibold uppercase tracking-[0.14em] ${FLAME}`}>Qué hacemos</div>
                <h2 className='m-0 text-[32px] font-extrabold leading-[1.05] tracking-[-0.03em] md:text-[44px]'>
                    Somos tu contable y tu asesor de hostelería. Tú te quedas con el oficio.
                </h2>
                <p className={`m-0 text-lg ${MUTED}`}>
                    Lo que harían dos personas en plantilla, con experiencia real en el sector y sin que tengas que
                    contratarlas ni dirigirlas.
                </p>
            </div>
            <div className='grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-5'>
                {WHAT_WE_DO.map(block => (
                    <div
                        key={block.title}
                        className='flex flex-col gap-4 rounded-[20px] border border-[#DDCFB8] bg-[#FAF6EE] p-8'
                    >
                        <h3 className={`m-0 text-[22px] font-bold ${block.tone === 'limit' ? FLAME : GREEN}`}>
                            {block.title}
                        </h3>
                        <ul className='m-0 flex list-disc flex-col gap-2.5 pl-5'>
                            {block.items.map(item => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    )
}
